<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="830" v-if="filialComputed !== undefined">
    <v-card>
      <v-card-title>Pontos de Venda - PDV</v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="d-flex justify-center">
              <v-icon size="150">mdi-cash-register</v-icon>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">

              <span class="title">{{ this.filialComputed.cc_fil }}, {{ this.filialComputed.nm_fil }}</span>

              <div v-if="itens.length === 0">
                Não há PDV cadastrado para esta filial
              </div>
              <v-simple-table fixed-header height="192" class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Token</th>
                      <th>Ativo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td><v-chip color="primary">{{ item.cc_pdv }}</v-chip></td>
                      <td style="word-break:break-all;"><b>Identifica&ccedil;&atilde;o</b>: {{ item.cc_tkn }}<br><b>Ativa&ccedil;&atilde;o</b>: {{ item.tx_dados_ativacao }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-icon color="primary" v-if="item.bl_tkn_atv" large v-on="on" @click="ativar(item)">mdi-check-circle</v-icon>
                          </template>
                          <span>Disponibilizar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-form  ref="formpdv" v-model="valid" :lazy-validation="lazy" id="formpdv" v-on:submit.prevent>
                <div class="d-flex flex-column">
                    <v-text-field v-model="cc_pdv" :rules="validacao.cc_pdv" required label="Código do PDV" class="mr-2"></v-text-field>
                    <v-btn depressed color="primary" @click="inserir()">INSERIR</v-btn>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed @click="modalComputed = false">
          FECHAR
      </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'PontoDeVenda',

  data() {
    return {

      lazy: false,
      valid: true,
      itens:[],
      cc_pdv: undefined,
      filialTemp: undefined,
      modalTemp: undefined,

      validacao: {
        cc_pdv: [
          (v) => !!v || 'Requerido',
          (v) => /^[0-9]{3}$/.test(v) || 'Formato inválido'
        ],
      }

    }
  },

  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {
    listar() {
      this.itens = []
      if(this.filialComputed !== undefined) {
        this.$store.dispatch('pesquisaPDV', {size:9999, cc_fil: this.filialComputed.cc_fil}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.formpdv.validate()) {
        this.$store.dispatch('salvarPDV', {cc_fil:this.filialComputed.cc_fil, cc_pdv: this.cc_pdv}).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    resetarFormulario(){
      this.$refs.formpdv.reset()
    },

    ativar(item) {
      this.$store.dispatch('ativarPDV', item.id_reg).then(() => {
        item.bl_tkn_atv = !item.bl_tkn_atv
      }).catch()
    }

  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {

    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')

  }

}
</script>